import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const i18nSeo = i18n.createInstance();

if (process.env.REACT_APP_SEO_CONTENT) {
    i18nSeo.use(Backend);
}

i18nSeo
    .use(initReactI18next)
    .init({
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true,
        },
        backend: process.env.REACT_APP_SEO_METADATA
            ? { loadPath: process.env.REACT_APP_SEO_METADATA }
            : undefined,
    });

export default i18nSeo;